// src/styles/theme.js
import { createDarkTheme, createLightTheme } from "@fluentui/react-components";

const brandPalette = {
  10: "#02050e",
  20: "#040a1a",
  30: "#060e25",
  40: "#081231",
  50: "#0a173c",
  60: "#0d1d4e",
  70: "#102360",
  80: "#152c78",
  90: "#1a368f",
  100: "#2040a5",
  110: "#274cba",
  120: "#3059ce",
  130: "#4068d9",
  140: "#5379e3",
  150: "#698cec",
  160: "#84a1f4",
};

export const lexTheme = {
  ...createDarkTheme(brandPalette),
  colorBrandBackground: "#c9a84c",
  colorBrandBackgroundHover: "#d4b560",
  colorBrandForeground1: "#c9a84c",
  colorNeutralBackground1: "#0a1628",
  colorNeutralBackground2: "#0d1e35",
  colorNeutralBackground3: "#111f38",
  colorNeutralBackground4: "#162440",
  colorNeutralForeground1: "#f0ede8",
  colorNeutralForeground2: "#c8c4bc",
  colorNeutralForeground3: "#8fa3c0",
  colorNeutralStroke1: "#1e3054",
  colorNeutralStroke2: "#1a2845",
};
